import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M16.6 12L7.3 2.7l1.4-1.4 10 10 .7.7-.7.7-10 10-1.4-1.4 9.3-9.3z", clipRule: "evenodd" }));
export {
  o as ReactComponent
};
